import '../App.css'
import React, { useEffect, useState } from 'react'
import Todo from '../components/Todo'
import { useSelector, useDispatch } from 'react-redux'
import { Plus } from 'react-feather'
import { addTodo, setTodos, setActiveTodos, setFinishedTodos } from '../store/action'

export default function Home () {
  const todos = useSelector(state => state.todos)
  const activeTodos = useSelector(state => state.activeTodos)
  const finishedTodos = useSelector(state => state.finishedTodos)
  console.log(activeTodos, '<<<<<< active todos')
  console.log(finishedTodos, '<<<<<< finished todos')
  const dispatch = useDispatch()
  const [userInput, setUserInput] = useState({
    id: 0,
    title: '',
    status: ''
  })
  console.log(todos, '<<<<< todos')
  const [category, setCategory] = useState('')

  useEffect(() => {
    console.log('Did Mason Mount')
  }, [])

  useEffect(() => {
    console.log('Did Kai Havertz')
    dispatch(setTodos(todos))
  }, [todos, dispatch])

  function createTodo (e) {
    e.preventDefault()
    dispatch(addTodo(userInput))
    setUserInput({id: 0, title: '', status: ''})
  }

  function showActiveTodos (e) {
    e.preventDefault()
    dispatch(setActiveTodos())
    setCategory('unfinished')
  }

  function showFinishedTodos (e) {
    e.preventDefault()
    dispatch(setFinishedTodos())
    setCategory('finished')
  }

  function showAllTodos (e) {
    e.preventDefault()
    setCategory('')
  }

  function renderingTodos () {
    if (category === '') {
      return (
        todos.map((todo, i) => {
          return <Todo
            status='unfilter'
            todo={todo}
            index={i}
            key={todo.id}
          />
        })
      )
    } else if (category === 'unfinished') {
      return (
        activeTodos.map((todo, i) => {
          return <Todo
            status='activeFilter'
            todo={todo}
            index={i}
            key={todo.id}
          />
        })
      )
    } else {
      return (
        finishedTodos.map((todo, i) => {
          return <Todo
            status='finishedFilter'
            todo={todo}
            index={i}
            key={todo.id}
          />
        })
      )
    }
  }

  return (
    <>
      <div className="container">
        <div className="Navbar">
          <div onClick={showAllTodos} className="navbar-link">All</div>
          <div onClick={showActiveTodos} className="navbar-link">Active</div>
          <div onClick={showFinishedTodos} className="navbar-link">Completed</div>
        </div>
        <div className="Form">
          <div className="Input-Todo form-group">
            <input value={userInput.title} onChange={e => setUserInput({ ...userInput, title: e.target.value, id: Math.floor(Math.random() * 1000), status: 'unfinished' } )} className="form-control form-control-lg" type="text" placeholder="What needs to be done" aria-label=".form-control-lg example"></input>
          </div>
          <div className="Input-btn form-group">
            <button onClick={createTodo} className="btn btn-warning"><Plus/></button>
          </div>
        </div>
        {
          renderingTodos()
        }
      </div>
    </>
  )
}